import Bounty from './Bounty'

export default Bounty